module.exports = __webpack_public_path__ + "static/media/resource-video.424730b2.svg";